<!--
* UIID:
* UI Name: Report List
* Modify Date: 2020/10/07
-->
<template>
  <div class="container">
    <!-- Page Header -->
    <v-row class="page-header">
      <v-col class="page-title" cols="12">
        <v-toolbar-title class="font-bold">{{$t('lbl.report.page_header')}}</v-toolbar-title>
      </v-col>
    </v-row>

    <!-- /**
          * 2021.07.30 203737 SPKA-169 issue 110 Change all text field and combo box style for search condition [Report]
    */-->
    <!-- Condition search -->
    <v-row class="custom-form-control custom-form-control-type-2 custom-figma-1">
      <v-col cols="12" class="search-conditions-display">
        <div class="pl-0 pt-0 pb-0 collapse-search-conditions hide">
          <v-btn
            class="btn btn-top"
            color="primary"
            @click.native="displaySearchConditions('collapse')"
          >
            <v-icon x-small class="mr-2">fa fa-chevron-up</v-icon>
            {{$t('btn.common.collapseConditions')}}
          </v-btn>
        </div>
        <div class="pl-0 pt-0 pb-0 expand-search-conditions">
          <v-btn
            class="btn btn-top"
            color="primary"
            @click.native="displaySearchConditions('expand')"
          >
            <v-icon x-small class="mr-2">fa fa-chevron-down</v-icon>
            {{$t('btn.common.expandConditions')}}
          </v-btn>
        </div>
      </v-col>
      <v-col cols="12" class="pt-0 pb-0">
        <v-row>
          <v-col
            class="comm-header-col data-query-section pb-0 pt-0 mt-0 custom-field-combo custom-figma-1"
            cols="12"
            xl="7"
            lg="7"
            md="7"
          >
            <v-row>
              <v-col
                v-if="$cookies.get('comp-id') === $cookies.get('ownr-id')"
                cols="12"
                md="2"
                class="pt-0 pb-0"
              >
                <v-autocomplete
                  v-model="company"
                  :label="$t('lbl.common.conditionSearch.selectCompany')"
                  :menu-props="{ offsetY: true, }"
                  :items="customerItem"
                  @keyup.enter="initialize"
                  @change="initialize"
                  dense
                  filled
                ></v-autocomplete>
              </v-col>
              <v-col v-else cols="12" md="2" class="pt-0 pb-0">
                <v-autocomplete
                  v-model="prnrId"
                  :items="getPrnrList"
                  @keyup.enter="initialize"
                  @change="initialize"
                  dense
                  filled
                  class="custom-selectbox"
                  :label="$t('lbl.common.conditionSearch.findbyPartner')"
                ></v-autocomplete>
              </v-col>

              <v-col cols="12" md="2" class="pt-0 pb-0">
                <v-text-field
                  v-model="senderId"
                  @keyup.enter="initialize"
                  dense
                  filled
                  class="custom-selectbox"
                  :label="$t('lbl.common.conditionSearch.findbySender')"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="2" class="pt-0 pb-0">
                <v-text-field
                  v-model="recipientId"
                  @keyup.enter="initialize"
                  dense
                  filled
                  class="custom-selectbox"
                  :label="$t('lbl.common.conditionSearch.findbyReceiver')"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="3" class="pt-0 pb-0">
                <v-autocomplete
                  v-model="message"
                  :items="EDIMesList"
                  dense
                  filled
                  class="custom-selectbox"
                  :label="$t('lbl.common.conditionSearch.findbyMessage')"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="2" class="pt-0 pb-0">
                <v-autocomplete
                  v-model="direction"
                  :items="directions"
                  @change="initialize"
                  dense
                  filled
                  class="custom-selectbox"
                  :label="$t('lbl.common.conditionSearch.findbyDirection')"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="1" class="pt-0 pb-0 pr-0"></v-col>
            </v-row>
          </v-col>
          <v-col
            class="comm-header-col date-query-section pb-0 pt-0 mt-0 text-right pr-0 custom-figma-1"
            cols="12"
            xl="5"
            lg="5"
            md="5"
          > 
            <div class="pl-0 pt-0 pb-0 d-inline-flex date-range">
              <v-autocomplete
                v-model="masterSearchItems.init.DAT_TYPE"
                :items="dateTypes"
                @change="changeDtTp"
                :menu-props="{offsetY: true,}"
                hide-details
                dense
                solo
                class="custom-selectbox"
                :label="$t('lbl.report.dateRange')"
              ></v-autocomplete>
            </div>
            <div class="pl-0 pt-0 pb-0 d-inline-flex">
              <v-menu
                ref="fromdate_menu"
                v-model="fromdate_menu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="masterSearchItems.init.FR_DAT"
                    :placeholder="' '"
                    :disabled="masterSearchItems.init.DAT_TYPE == undefined || masterSearchItems.init.DAT_TYPE == null || masterSearchItems.init.DAT_TYPE == ''"
                    append-icon="mdi-calendar"
                    dense
                    solo
                    @keypress="formatDate('from', $event)"
                    @change="changeDate('from')"
                    @click:append="on.click"
                    :class="['date-text', $vuetify.theme.dark ? '' : 'font-semibold']"
                  ></v-text-field>
                </template>
                <v-date-picker
                  class="date-period-picker"
                  v-model="masterSearchItems.init.FR_DAT"
                  :max="getMaxDate"
                  @input="fromdate_menu = false; changeDate('from')"
                  no-title
                  scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="fromdate_menu = false">
                    {{
                    $t("btn.common.cancel")
                    }}
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="
                      $refs.fromdate_menu.save(masterSearchItems.init.FR_DAT)
                    "
                  >{{ $t("btn.common.ok") }}</v-btn>
                </v-date-picker>
              </v-menu>
            </div>
            <div class="pl-0 pt-0 pb-0 d-inline-flex">
              <v-menu
                ref="todate_menu"
                v-model="todate_menu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="masterSearchItems.init.TO_DAT"
                    :placeholder="' '"
                    :disabled="masterSearchItems.init.DAT_TYPE == undefined || masterSearchItems.init.DAT_TYPE == null || masterSearchItems.init.DAT_TYPE == ''"
                    append-icon="mdi-calendar"
                    dense
                    solo
                    @keypress="formatDate('to', $event)"
                    @change="changeDate('to')"
                    @click:append="on.click"
                    :class="['date-text', $vuetify.theme.dark ? '' : 'font-semibold']"
                  ></v-text-field>
                </template>
                <v-date-picker
                  class="date-period-picker"
                  :allowed-dates="allowedDates"
                  v-model="masterSearchItems.init.TO_DAT"
                  @input="todate_menu = false; changeDate('to')"
                  no-title
                  scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="todate_menu = false">
                    {{
                    $t("btn.common.cancel")
                    }}
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="
                      $refs.todate_menu.save(masterSearchItems.init.TO_DAT)
                    "
                  >{{ $t("btn.common.ok") }}</v-btn>
                </v-date-picker>
              </v-menu>
            </div>
            <div class="pl-0 pt-0 pb-0 d-inline-flex btn-control">
              <v-btn
                class="btn btn-top btn-search btn-width-1"
                color="primary"
                @click.native="initialize"
              >
                <v-icon x-small class="mr-1">fa fa-search</v-icon>
                {{ $t("btn.common.search") }}
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-row class="custom-pagination-figma-v3-first">
      <v-col class="page-control-content page-control-bg">
        <v-row>
          <v-col lg="6" md="6"></v-col>
          <v-col lg="2" md="1"></v-col>
          <v-col lg="4" md="5" class="filter-search">
            <v-row>
              <v-col class="mr-0 pr-0 pl-0" lg="5" md="5">
                <v-select
                  v-model="searchBy"
                  :items="searchByItems"
                  :placeholder="$t('lbl.common.searchTypePlaceHolder')"
                  @change="onFilterReportList"
                  class="search-by data-table-select-box custom-selectbox pla-col mr-0 flat-file-selectbox"
                  height="40"
                  hide-details
                  dense
                  solo
                ></v-select>
              </v-col>
              <v-col class="ml-0 pl-0" cols="12" md="7">
                <v-text-field
                  v-model="search"
                  :placeholder="$t('lbl.common.searchPlaceHolder')"
                  @input="onFilterReportList"
                  @click:append="onFilterReportList"
                  @keyup.enter="onFilterReportList"
                  class="data-table-filter-text-field search-button-data-analysis-table flat-file"
                  heigth="40"
                  append-icon="fa fa-search"
                  hide-details
                  dense
                  solo
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <!-- Grid table page -->
    <v-row>
      <v-col cols="12" class="pt-0 pb-0">
        <v-data-table
          :headers="headers"
          :items="listData"
          :hide-default-footer="true"
          :hide-default-header="true"
          :class="['list-table code-table srm-list-table custom-report-header custom-border-table', listData.length > 0 ? '' : 'custom-border-table-merge-not-data']"
          disable-pagination
          :fixed-header="true"
          :height="tableHeight"
          :group-by="group"
          @click:row="rowClick"
          item-key="INDEX"
          single-select
        >
          <template v-slot:group.header="{ group, items, isOpen, toggle, remove }">
            <td colspan="5" class="count-col">
              <v-btn icon @click="toggle" width="30">
                <v-icon v-if="isOpen" small>mdi-minus</v-icon>
                <v-icon v-else small>mdi-plus</v-icon>
              </v-btn>
              <span class="ml-2">{{ `${groupData[group].name} - [ ${group} ]` }}</span>
            </td>
            <td class="text-right total-col success-col">{{ groupData[group].successCount }}</td>
            <td class="text-right total-col error-col">{{ groupData[group].failCount }}</td>
            <td
              class="text-right total-col error-col"
            >{{ calErrorRate(groupData[group].failCount , groupData[group].totalCount)}}</td>
            <td class="text-right total-col">{{ groupData[group].inputFileSize }}</td>
            <td class="text-right total-col">{{ groupData[group].outputFileSize }}</td>
          </template>
          <!-- Grid table header -->
          <template v-slot:header="{ props: {headers} }">
            <thead class="v-data-table-header">
              <tr>
                <th
                  role="columnheader"
                  scope="col"
                  aria-sort="none"
                  class="text-start sortable"
                  rowspan="2"
                >
                  <span>{{headers[0].text}}</span>
                  <i
                    aria-hidden="true"
                    class="v-icon notranslate v-data-table-header__icon mdi mdi-arrow-up theme--dark"
                    style="font-size: 18px;"
                  ></i>
                </th>
                <th
                  role="columnheader"
                  scope="col"
                  aria-sort="none"
                  class="text-start sortable"
                  rowspan="2"
                >
                  <span>{{headers[1].text}}</span>
                  <i
                    aria-hidden="true"
                    class="v-icon notranslate v-data-table-header__icon mdi mdi-arrow-up theme--dark"
                    style="font-size: 18px;"
                  ></i>
                </th>
                <th
                  role="columnheader"
                  scope="col"
                  aria-sort="none"
                  class="text-center sortable"
                  rowspan="2"
                >
                  <span>{{headers[2].text}}</span>
                  <i
                    aria-hidden="true"
                    class="v-icon notranslate v-data-table-header__icon mdi mdi-arrow-up theme--dark"
                    style="font-size: 18px;"
                  ></i>
                </th>
                <th
                  role="columnheader"
                  scope="col"
                  aria-sort="none"
                  class="text-start sortable"
                  rowspan="2"
                >
                  <span>{{headers[3].text}}</span>
                  <i
                    aria-hidden="true"
                    class="v-icon notranslate v-data-table-header__icon mdi mdi-arrow-up theme--dark"
                    style="font-size: 18px;"
                  ></i>
                </th>
                <th role="columnheader" scope="col" class="text-center" rowspan="2">
                  <span>{{headers[4].text}}</span>
                </th>
                <th
                  role="columnheader"
                  scope="col"
                  aria-sort="none"
                  class="text-center sortable merge-col"
                  colspan="3"
                >
                  <span>Transaction Count</span>
                </th>
                <th
                  role="columnheader"
                  scope="col"
                  aria-sort="none"
                  class="text-left sortable"
                  rowspan="2"
                >
                  <span>{{headers[8].text}}</span>
                  <i
                    aria-hidden="true"
                    class="v-icon notranslate v-data-table-header__icon mdi mdi-arrow-up theme--dark"
                    style="font-size: 18px;"
                  ></i>
                </th>
                <th
                  role="columnheader"
                  scope="col"
                  aria-sort="none"
                  class="text-left sortable"
                  rowspan="2"
                >
                  <span>{{headers[9].text}}</span>
                  <i
                    aria-hidden="true"
                    class="v-icon notranslate v-data-table-header__icon mdi mdi-arrow-up theme--dark"
                    style="font-size: 18px;"
                  ></i>
                </th>
              </tr>
              <tr>
                <th
                  role="columnheader"
                  scope="col"
                  aria-sort="none"
                  class="text-center sortable merge-col"
                  :style="$vuetify.theme.dark ? 'border-left: 1px solid #525860 !important' : ''"
                >
                  <span>{{headers[5].text}}</span>
                  <i
                    aria-hidden="true"
                    class="v-icon notranslate v-data-table-header__icon mdi mdi-arrow-up theme--dark"
                    style="font-size: 18px;"
                  ></i>
                </th>
                <th
                  role="columnheader"
                  scope="col"
                  aria-sort="none"
                  class="text-start sortable merge-col"
                >
                  <span>{{headers[6].text}}</span>
                  <i
                    aria-hidden="true"
                    class="v-icon notranslate v-data-table-header__icon mdi mdi-arrow-up theme--dark"
                    style="font-size: 18px;"
                  ></i>
                </th>
                <th
                  role="columnheader"
                  scope="col"
                  aria-label="Manage"
                  class="text-center merge-col"
                  :style="$vuetify.theme.light ? 'border-right: 1px solid #c5d1e3 !important' : ''"
                >
                  <span>{{headers[7].text}}</span>
                </th>
              </tr>
            </thead>
          </template>
          <!-- Grid table total -->
          <template v-slot:item.senderId="{ item }">
            <font class="sender-col">{{item.senderId}}</font>
          </template>
          <template v-slot:item.recipientId="{ item }">
            <font class="receiver-col">{{item.recipientId}}</font>
          </template>
          <template v-slot:item.messageName="{ item }">
            <font class="message-col">{{item.messageName}}</font>
          </template>
          <template v-slot:item.direction="{ item }">
            <font>{{directionText(item.direction)}}</font>
          </template>
          <template v-slot:item.successCount="{ item }">
            <div class="text-right success-col">{{item.successCount}}</div>
          </template>
          <template v-slot:item.failCount="{ item }">
            <div class="text-right error-col">{{item.failCount}}</div>
          </template>
          <template v-slot:item.error_rate="{ item }">
            <div class="text-right error-col">{{ calErrorRate(item.failCount , item.totalCount) }}</div>
          </template>
          <template v-slot:item.inputFileSize="{ item }">
            <div class="text-right">{{item.inputFileSize}}</div>
          </template>
          <template v-slot:item.outputFileSize="{ item }">
            <div class="text-right">{{item.outputFileSize}}</div>
          </template>
          <template v-slot:body.append>
            <tr>
              <td
                class="text-xs-left count-col"
                colspan="5"
                :class="headers[0].text =='Direction' ? 'direction-col' : 'partner-col'"
                :style="$vuetify.theme.light ? 'border-top: 1px solid #c5d1e3 !important' : ''"
              >
                <span class="ml-10">Total</span>
              </td>
              <td class="text-right total-col success-col" :style="$vuetify.theme.light ? 'border-top: 1px solid #c5d1e3 !important' : ''">{{ totalData.successCount }}</td>
              <td class="text-right total-col error-col" :style="$vuetify.theme.light ? 'border-top: 1px solid #c5d1e3 !important' : ''">{{ totalData.failCount }}</td>
              <td
                class="text-right total-col error-col"
                :style="$vuetify.theme.light ? 'border-top: 1px solid #c5d1e3 !important' : ''"
              >{{ calErrorRate(totalData.failCount ,totalData.totalCount) }}</td>
              <td class="text-right total-col" :style="$vuetify.theme.light ? 'border-top: 1px solid #c5d1e3 !important' : ''">{{ totalData.inputFileSize }}</td>
              <td class="text-right total-col" :style="$vuetify.theme.light ? 'border-top: 1px solid #c5d1e3 !important' : ''">{{ totalData.outputFileSize }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <dialogWindow
      ref="SearchCondition"
      size="max"
      title="Search"
      :detail="$t('msg.common.fromDateValidate')"
      color="validation"
    ></dialogWindow>
    <dialogWindow
      ref="validateDate"
      size="max"
      :detail='$t("msg.common.validateDate")'
      color="validation"
    ></dialogWindow>
  </div>
</template>
<script>
import dialogWindow from "@/vue-dlb/components/NewDialog.vue";

import $ from "jquery";
import { deleteDateFormatStr } from "@/vue-dlb/utils/util";
import { beforeOneMonth } from "@/vue-dlb/utils/util";
import { getAppliedTimeZone } from "@/vue-dlb/utils/util";
import { dateValidation } from "@/vue-dlb/utils/util";
import { mapState } from "vuex";

import { resizeTableHeight } from "@/vue-dlb/common/common";
import cfg from "@/vue-caas/config/config.js";
export default {
  components: {
    dialogWindow,
  },
  computed: {
    getPrnrList() {
      return this.prnrList;
    },
    getMaxDate() {
      if (
        dateValidation(
          deleteDateFormatStr(this.masterSearchItems.init.FR_DAT),
          deleteDateFormatStr(this.masterSearchItems.init.TO_DAT)
        )
      ) {
        return this.masterSearchItems.init.TO_DAT;
      } else {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.$refs.SearchCondition.dialog = true;
        return this.masterSearchItems.init.TO_DAT;
      }
    },
    getMinDate() {
      if (
        dateValidation(
          deleteDateFormatStr(this.masterSearchItems.init.FR_DAT),
          deleteDateFormatStr(this.masterSearchItems.init.TO_DAT)
        )
      ) {
        return this.masterSearchItems.init.FR_DAT;
      } else {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.$refs.SearchCondition.dialog = true;
        return this.masterSearchItems.init.FR_DAT;
      }
    },
    ...mapState("common", {
      CommMsgList: "CommMsgList",
    }),
  },
  data() {
    return {
      dateCond: true,
      ompany: null, // 2021.6.10 163189 SKPA-134: Remove default
      userId: "",
      partner: "",
      senderId: "",
      recipientId: "",
      direction: null,
      message: null,
      EDIMesList: [
        { text: this.$t("lbl.common.conditionSearch.all"), value: "" },
      ],
      customerItem: [
        { text: this.$t("lbl.common.conditionSearch.all"), value: "" },
      ],
      directions: [
        { text: this.$t("lbl.common.conditionSearch.all"), value: "" },
        { text: "INBOUND", value: "I" },
        { text: "OUTBOUND", value: "O" },
      ],
      listData: [],
      totalCnt: 0,
      groupData: [],
      totalData: {
        received_count_total: 0,
        sent_count_total: 0,
        successCount: 0,
        failCount: 0,
        inputFileSize: 0,
        outputFileSize: 0,
        totalCount: 0,
      },
      prnrList: [{ text: "Select Partner", value: "" }],
      ownrId: "",
      groupId: "",
      company: null,
      prnrId: null,
      dateTypes: [
        { value: "UPDT", text: "Update Date" },
      ],
      // old
      isPartner: false,
      c_index: -1,
      isDesc: true,
      isOpen: true,
      check: false,
      fromdate_menu: false,
      todate_menu: false,
      isCreated: false,
      dateTimeFormat: "",
      tableHeight: "",
      search: "",
      searchBy: "all",
      group: "partnerId",
      typeGroup: "Partner",
      masterSearchItems: {
        init: {
          FR_DAT: beforeOneMonth(),
          TO_DAT: getAppliedTimeZone(),
          FR_DAT_PREV: beforeOneMonth(),
          TO_DAT_PREV: getAppliedTimeZone(),
          FR_DAT_ERROR: [],
          TO_DAT_ERROR: [],
          DAT_TYPE: "UPDT",
        },
      },
      itemShow: [
        { text: "Show 10", value: 10 },
        { text: "Show 25", value: 25 },
        { text: "Show 50", value: 50 },
        { text: "Show 75", value: 75 },
        { text: "Show 100", value: 100 },
      ],
      headers: [
        { text: "Partner", value: "", index: 1 },
        { text: "Sender", value: "senderId", index: 2 },
        { text: "Receiver", value: "recipientId", index: 3 },
        { text: "Message", value: "messageName", index: 4 },
        { text: "Direction", value: "direction", index: 5 },
        { text: "Success", value: "successCount", index: 6 },
        { text: "Error", value: "failCount", index: 7 },
        { text: "Error Rate (%)", value: "error_rate", index: 8 },
        { text: "Received Data Size", value: "inputFileSize", index: 9 },
        { text: "Sent Data Size", value: "outputFileSize", index: 10 },
      ],
      searchByItems: [
        { text: this.$t("lbl.common.searchTypePlaceHolder"), value: "all" },
        { text: "Sender", value: "senderId" },
        { text: "Receiver", value: "recipientId" },
        { text: "Message", value: "messageName" },
        { text: "Direction", value: "direction" },
      ],
      reports: [],
      groupPartnerTotals: {},
      groupDirectionTotals: {},
      totals: {},
      selectedId: -1
    };
  },
  methods: {
    displaySearchConditions(action) {
      if(action === 'expand') {
        $(".date-query-section").css("display", "block");
        $(".data-query-section").css("display", "block");
        $(".expand-search-conditions").css("display", "none");
        $(".collapse-search-conditions").css("display", "block");
      } else {
        $(".date-query-section").css("display", "none");
        $(".data-query-section").css("display", "none");
        $(".expand-search-conditions").css("display", "block");
        $(".collapse-search-conditions").css("display", "none");
      }
    },
    validateDateInput(dateString) {
      var regEx = /^\d{4}-\d{2}-\d{2}$/;
      if(!dateString.match(regEx)) return false;  // Invalid format
      var d = new Date(dateString);
      var dNum = d.getTime();
      if(!dNum && dNum !== 0) return false; // NaN value, Invalid date
      return d.toISOString().slice(0,10) === dateString;
    },
    formatDate(side, evt) {
      let dateString = (side === 'from') ? this.masterSearchItems.init.FR_DAT: this.masterSearchItems.init.TO_DAT
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46 && charCode !== 45) {
        evt.preventDefault();
      } else if ((charCode !== 46 && charCode !== 8 && charCode !== 45 &&  dateString.length === 4 && !dateString.includes("-")) || 
      (charCode !== 46 && charCode !== 8 && charCode !== 45 &&  dateString.length === 7 && dateString[4] === '-' && ((dateString.match(/-/g) || []).length == 1))) {
        dateString += '-';
        (side === 'from') ? (this.masterSearchItems.init.FR_DAT = dateString) : (this.masterSearchItems.init.TO_DAT = dateString)
      } else {
        return true;
      }
    },
    changeDate(side) {
      if (side === 'from') {
        if(!this.validateDateInput(this.masterSearchItems.init.FR_DAT)) {
          this.$refs.validateDate.dialog = true;
          this.masterSearchItems.init.FR_DAT = getAppliedTimeZone();
          this.masterSearchItems.init.TO_DAT = getAppliedTimeZone();
          return;
        }
        if (this.masterSearchItems.init.FR_DAT > getAppliedTimeZone()) {
          this.masterSearchItems.init.FR_DAT = getAppliedTimeZone();
        }
        if (this.masterSearchItems.init.FR_DAT > this.masterSearchItems.init.TO_DAT) {
          this.masterSearchItems.init.TO_DAT = this.masterSearchItems.init.FR_DAT
        }
      }
      if (side === 'to') {
        if(!this.validateDateInput(this.masterSearchItems.init.TO_DAT)) {
          this.$refs.validateDate.dialog = true;
          this.masterSearchItems.init.TO_DAT = getAppliedTimeZone();
          this.masterSearchItems.init.FR_DAT = getAppliedTimeZone();
          return;
        }
        if (this.masterSearchItems.init.TO_DAT > getAppliedTimeZone()) {
          this.masterSearchItems.init.TO_DAT = getAppliedTimeZone();
        }
        if (this.masterSearchItems.init.FR_DAT > this.masterSearchItems.init.TO_DAT) {
          this.masterSearchItems.init.FR_DAT = this.masterSearchItems.init.TO_DAT
        }
      }
    },
    rowClick: function (item, row) {
      row.select(true);
      this.selectedId=item.INDEX
    },
    changeDtTp() {
      if (
        this.masterSearchItems.init.DAT_TYPE == undefined ||
        this.masterSearchItems.init.DAT_TYPE == null ||
        this.masterSearchItems.init.DAT_TYPE == ""
      ) {
        this.dateCond = false;
        this.masterSearchItems.init.FR_DAT = "";
        this.masterSearchItems.init.TO_DAT = "";
      } else {
        this.dateCond = true;
        this.masterSearchItems.init.FR_DAT =
          this.masterSearchItems.init.FR_DAT || beforeOneMonth();
        this.masterSearchItems.init.TO_DAT =
          this.masterSearchItems.init.TO_DAT || getAppliedTimeZone();
      }
    },
    getPartnerList() {
      this.prnrList = [
        { text: this.$t("lbl.common.conditionSearch.all"), value: "" },
        { text: "*", value: "*" },
      ];
      this.$store.dispatch("getPartnerUseList").then(() => {
        const tmpPrnrList = this.$store.getters.partnerUseList;
        for (let i = 0; i < tmpPrnrList.length; i += 1) {
          const tmpPrnr = tmpPrnrList[i];
          const tmp = { text: tmpPrnr.prnrNm, value: tmpPrnr.prnrId };
          this.prnrList.push(tmp);
        }
      });
    },
    calErrorRate(a, b) {
      return isNaN(a / b) ? 0 : a / b === 0 ? 0 : ((a / b) * 100).toFixed(3);
    },
    directionText(direction) {
      if (direction === "I") return "Inbound";
      else if (direction === "O") return "Outbound";
    },
    getEDIMsgTypeList() {
      let commMsgSearchItems = {
        header: ["MSG_NM"],
        data: [
          {
            MSG_NM: "",
          },
        ],
      };
      Store.dispatch("common/getCommonMessageList", commMsgSearchItems).then(
        () => {
          console.log("--------- Finished to process MES ----------");
          for (let i = 0; i < this.CommMsgList.length; i++) {
            let EDIVerObj = {};
            EDIVerObj.text =
              this.CommMsgList[i].MSG_CD +
              " (" +
              this.CommMsgList[i].MSG_NM +
              ")";
            EDIVerObj.value = this.CommMsgList[i].MSG_CD;
            this.EDIMesList.push(EDIVerObj);
          }
        }
      );
    },
    getParamData(pageChange) {
      const params = {};
      this.userId = this.$cookies.get("user-id");
      this.gmtTmzn = this.$cookies.get("gmt-timezone");
      params.ownrId = this.$cookies.get("ownr-id");
      params.groupId = this.$cookies.get("comp-id");
      params.prnrId = this.prnrId;
      params.company = this.company;
      params.userId = this.userId;
      params.senderId = this.senderId;
      params.recipientId = this.recipientId;
      params.partner = this.partner;
      params.message =
        this.message == undefined || this.message == null
          ? ""
          : this.message.trim();
      params.fromDateData = this.masterSearchItems.init.FR_DAT;
      params.toDateData = this.masterSearchItems.init.TO_DAT;
      params.dateCond = this.dateCond;
      params.direction =
        this.direction == undefined || this.direction == null
          ? ""
          : this.direction; // 2021.6.10 163189 SKPA-134: Remove default,
      return params;
    },
    initialize(pageChange) {
      // 203737 05/11/2021 SPKA-98 issue 53 Fix spiner when search list again
      this.isLoading = true;
      if (
        dateValidation(
          deleteDateFormatStr(this.masterSearchItems.init.FR_DAT),
          deleteDateFormatStr(this.masterSearchItems.init.TO_DAT)
        )
      ) {
        this.group =
          this.$cookies.get("comp-id") === this.$cookies.get("ownr-id")
            ? "userId"
            : "partnerId";
        // 2021.11.10 203728 SPKA-245 set Search params
        this.paramSearch = this.getParamData(pageChange);
        this.$store
          .dispatch("getReportList", this.paramSearch)
          .then(() => {
            this.listData = this.$store.getters.reportList.data;
            this.groupData = this.$store.getters.reportList.groupData;
            this.totalData = this.$store.getters.reportList.totalData;

            if (this.group === "userId") {
              for (let k = 0; k < this.customerItem.length; k += 1) {
                if (this.groupData[this.customerItem[k].value]) {
                  this.groupData[
                    this.customerItem[k].value
                  ].name = this.customerItem[k].text;
                }
              }
            }

            //2021.11.22 203728 if total % items = 0
            this.totalCnt = this.$store.getters.totalReportCnt;
            this.searchByTxt = "";
            this.searchBy = "all";
            this.onFilterReportList();
            this.listData.map(
              (e, i) => (e.INDEX = i + 1)
            );
            // 203728 - hide progress when expired time.
            this.isLoading = false;
          })
          .catch((ex) => {
            this.isLoading = false;
          });
      } else {
        this.isLoading = false;
        this.$refs.DateValidation.dialog = true;
        this.checkDialogColor = "validation";
        this.checkDialogTitle = "Search";
        this.checkDialogInfo = this.$t("msg.common.fromDateValidate");
      }
    },
    sortData(prop, type) {
      let ref = "sort" + type;
      let arr = Object.keys(this.$refs);
      let arrSort = arr.filter((item) => {
        if (item.includes("sort")) {
          return true;
        }
        return false;
      });
      for (let i = 0; i < arrSort.length; i++) {
        if (ref != this.$refs[arrSort[i]]) {
          let classList = this.$refs[arrSort[i]].$el.classList;
          classList.replace("fa-arrow-down", "fa-arrow-up");
        }
      }
      let classList = this.$refs[ref].$el.classList;
      if (prop == "partner") {
        if (this.isPartner) {
          classList.replace("fa-arrow-down", "fa-arrow-up");
          this.isPartner = false;
        } else {
          classList.replace("fa-arrow-up", "fa-arrow-down");
          this.isPartner = true;
        }
      }
      if (this.isDesc) {
        classList.replace("fa-arrow-down", "fa-arrow-up");
        this.isDesc = false;
        this.reports.sort((a, b) => {
          return a[prop] < b[prop] ? -1 : 1;
        });
      } else {
        classList.replace("fa-arrow-up", "fa-arrow-down");

        this.isDesc = true;
        this.reports.sort((a, b) => {
          return a[prop] > b[prop] ? -1 : 1;
        });
      }
    },

    changeView() {
      this.reports.forEach((item) => {
        item.hide = false;
      });
      if (this.typeGroup == "Direction") {
        for (var k in this.groupDirectionTotals) {
          this.reports.forEach((item) => {
            if (k == item.direction) {
              item.received_count_total = this.formatNumber(
                this.groupDirectionTotals[k].received_count_total
              );
              item.sent_count_total = this.formatNumber(
                this.groupDirectionTotals[k].sent_count_total
              );
              item.success_total = this.formatNumber(
                this.groupDirectionTotals[k].success_total
              );
              item.error_total = this.formatNumber(
                this.groupDirectionTotals[k].error_total
              );
              item.error_rate_total = this.formatNumber(
                this.groupDirectionTotals[k].error_rate_total
              );
              item.received_data_size_total = this.formatNumber(
                this.groupDirectionTotals[k].received_data_size_total
              );
              item.sent_data_size_total = this.formatNumber(
                this.groupDirectionTotals[k].sent_data_size_total
              );
            }
          });
        }
        let indexPartner = this.headers.findIndex((val) => {
          return val.text === "Partner";
        });
        let indexDirection = this.headers.findIndex((val) => {
          return val.text === "Direction";
        });
        var temp = this.headers[indexPartner];
        this.headers[indexPartner] = this.headers[indexDirection];
        this.headers[indexDirection] = temp;
        this.group = "direction";
      } else {
        for (var k in this.groupPartnerTotals) {
          this.reports.forEach((item) => {
            if (k == item.partner) {
              item.received_count_total = this.formatNumber(
                this.groupPartnerTotals[k].received_count_total
              );
              item.sent_count_total = this.formatNumber(
                this.groupPartnerTotals[k].sent_count_total
              );
              item.success_total = this.formatNumber(
                this.groupPartnerTotals[k].success_total
              );
              item.error_total = this.formatNumber(
                this.groupPartnerTotals[k].error_total
              );
              item.error_rate_total = this.formatNumber(
                this.groupPartnerTotals[k].error_rate_total
              );
              item.received_data_size_total = this.formatNumber(
                this.groupPartnerTotals[k].received_data_size_total
              );
              item.sent_data_size_total = this.formatNumber(
                this.groupPartnerTotals[k].sent_data_size_total
              );
            }
          });
        }
        let indexPartner = this.headers.findIndex((val) => {
          return val.text === "Partner";
        });
        let indexDirection = this.headers.findIndex((val) => {
          return val.text === "Direction";
        });
        var temp = this.headers[indexPartner];
        this.headers[indexPartner] = this.headers[indexDirection];
        this.headers[indexDirection] = temp;
        this.group = "partner";
      }
    },
    toggle(group) {
      this.reports.forEach((item) => {
        if (item[this.group] === group) {
          item.hide = !item.hide;
        }
      });
    },
    findIndexItem(item, arr, col) {
      let prop = typeof col == "undefined" ? "id" : col;
      let index = arr.findIndex((row) => {
        return row[prop] === item[prop];
      });
      return index > -1 ? index : null;
    },
    allowedDates(val) {
      let date = getAppliedTimeZone();
      if (val <= date) {
        return val;
      }
    },
    expandData(event, item) {
      console.log($(event.target));
      let showData = ".show-data" + item.id;
      var strIcon = $(event.target)[0].classList;
      if (strIcon.contains("fa-minus")) {
        $(showData).css("display", "none");
        var str = $(event.target)[0].className;
        $(event.target)[0].className = str.replace("fa-minus", "fa-plus");
      } else {
        $(showData).css("display", "table-row");
        var str = $(event.target)[0].className;
        $(event.target)[0].className = str.replace("fa-plus", "fa-minus");
      }
      console.log(temp);
    },
    formatNumber(data) {
      var numberFormat = Intl.NumberFormat();
      data = numberFormat.format(data);
      return data;
    },
    onFilterReportList(str) {
      console.log(this.searchBy);
      console.log(this.search);
      this.$store.commit("SET_STORE_REPORT_FILTER", {
        filter: this.searchBy,
        str: this.search,
      });
      this.reports = this.$store.getters.reportList;
      console.log(this.reports);
    },
  },
  watch: {
  },
  updated: function () {
    let self = this;
    let arrClassMinus = [".page-control-content", ".page-control-content"];
    let arrClassPlus = [];

    if (this.isCreated) {
      let h1 = resizeTableHeight(arrClassMinus, arrClassPlus, true);
      self.tableHeight = h1 + 105 + "px";
      this.isCreated = false;
    }

    $(window).resize(function (event) {
      let h1 = resizeTableHeight(arrClassMinus, arrClassPlus, true);
      self.tableHeight = h1 + 105 + "px";
    });
  },
  created() {
    this.isCreated = true;
    this.getPartnerList();
    this.$store.dispatch("getCompanyList").then(() => {
      console.log("--------- Finished to process Customer List ----------");
      this.$store.getters.companies.forEach((element) => {
        let codeObj = {};
        codeObj.text = element.compNm;
        codeObj.value = element.compId;
        this.customerItem.push(codeObj);
      });
    });
    this.getEDIMsgTypeList();
    this.initialize();
  },
};
</script>
<style lang="scss">
.test table tr {
  border-style: none;
}
.group-type-radio {
  .mdi-radiobox-marked,
  .mdi-radiobox-blank,
  label {
    font-size: 14px;
  }
}
.theme--dark.v-data-table.group-table thead tr:first-child th {
  background-color: #191a21;
  color: #bbbbbb !important;
}
.theme--dark.v-data-table.v-data-table--fixed-header.group-table
  thead
  tr:first-child
  th {
  border: none !important;
  border-right: 1px solid #525860 !important;
  border-bottom: 1px solid #525860 !important;
  border-top: 1px solid #525860 !important;
}
.theme--dark.v-data-table.v-data-table--fixed-header.group-table
  thead
  tr:first-child
  th:first-child {
  border-left: 1px solid #525860 !important;
}
.theme--dark.v-data-table.v-data-table--fixed-header.group-table
  thead
  tr:last-child
  th {
  border-top: none !important;
}
.theme--dark.v-data-table.v-data-table--fixed-header.group-table
  thead
  tr:last-child
  th:first-child {
  border-left: none !important;
}
.theme--light.v-data-table.v-data-table--fixed-header.group-table
  thead
  tr:last-child
  th {
  border-top: 1px solid #ffffff !important;
}
.theme--dark .group-type-radio .partner-radio {
  i,
  label {
    color: #00b8d9 !important;
  }
}
.theme--dark .group-type-radio .direction-radio {
  i,
  label {
    color: #6f5ece !important;
  }
}
.theme--light .group-type-radio .partner-radio {
  i,
  label {
    color: #00b8d9 !important;
  }
}
.theme--light .group-type-radio .direction-radio {
  i,
  label {
    color: #6f5ece !important;
  }
}
.group-table {
  .direction-col {
    color: #6f5ece !important;
  }
  .partner-col {
    color: #00b8d9 !important;
  }
  .success-col {
    color: #2ff1b2 !important;
  }
  .error-col {
    color: #eb1e50 !important;
  }
  .total-col {
    font-weight: bold;
    color: #ffffff;
  }
  .merge-col {
    width: 150px;
  }
  .data-size-col {
    width: 200px;
  }
}
.icon-sort:hover {
  opacity: 1;
}
.icon-sort {
  opacity: 0;
}
.comm-header-col.custom-figma-1.date-query-section.fixed-float
  .d-inline-flex.date-range {
  width: 25% !important;
}
</style>
